module.exports = __webpack_public_path__ + "img/company-logo.e93fd6dc.svg";